export class EoProgressSubscriptions {
  id: number;
  enteredAt: Date;
  enteredBy: string;
}
